module.exports = __webpack_public_path__ + "img/button-metamask-fox.350d9f1c.svg";